/* eslint-disable no-script-url */
import * as React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

import SideNavBar from '../SideNavBar/SideNavBar'
import ActionButton from '../ActionButton/ActionButton'
import Icon from '../Icon/Icon'
import SearchModal from '../../home/SearchModal/SearchModal'
//import BrandLogo from '../../branding/Logo/Logo'
import BrandLogo from '../../../assets/img/ayala-malls-logo.svg'

import SelectMallPromptModal from '../../home/SelectMallPromptModal/SelectMallPromptModal'
import MallWelcomeModal from '../../home/MallWelcomeModal/MallWelcomeModal'

import * as ProfileApiServices from '../../../services/api/requests/Profile'
import * as MallApiService from '../../../services/api/requests/Mall'
import * as NotificationsApiServices from '../../../services/api/requests/Notifications'
import * as WatchApiServices from '../../../services/api/requests/Watch'
import getMobileOS from '../../../services/data/getMobileOS'

import { deleteAccessToken } from '../../../services/data/accessToken'

import Brand from '../../../assets/img/brand.webp'
import Burger from '../../../assets/img/burger.png'
import SearchIcon from '../../../assets/img/search-icon.svg'

import media from '../../../services/generateMediaQueries'
import getDeviceLocation from '../../../services/location/getDeviceLocation'

import DownloadAppModal from '../DownloadAppModal/DownloadAppModal'
import areAdsAllowed from '../../../services/ads/areAdsAllowed'
import { deleteUuid } from '../../../services/data/webUuid'
import { doOpenSureSeats } from '../../../controllers/SSO'
import { setGACustomEvent } from '../../../services/analytics/google-analytics'

const HeaderContainer = styled.div`
  position: sticky;
  width: 100%;
  z-index: 5;
  top: 0;
`

const StyledHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
  z-index: 99;
  width: 100%;
  min-height: 5rem;
  transition: all var(--animation-duration) var(--animation-easing);
`

const HeaderBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: linear-gradient(
    to right,
    rgba(231, 71, 94, 1) 0%,
    rgba(235, 118, 50, 1) 100%
  );
  opacity: 0;
  box-shadow: var(--box-shadow-large);
`

const Nav = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  flex: 1;

  &:nth-child(5) {
    justify-content: center;
  }

  &:nth-child(6) {
    justify-content: flex-end;
  }

  ${props =>
    props.collapse &&
    media.lessThan(props.collapse)`
    display: none;
  `}

  ${props =>
    props.showOn &&
    css`
      display: none;
    `}

  ${props =>
    props.showOn &&
    media.lessThan(props.showOn)`
    display: flex;
  `}
`

const NavItem = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 5rem;
  min-height: 5rem;
  color: #ffffff;
  font-size: 1rem;
  text-transform: uppercase;
  white-space: pre;
  margin: 0 1.5rem;
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  ${props =>
    props.brand &&
    css`
      margin: 0 !important;
      justify-content: center;

      ${props.hasBackground &&
        css`
          background: var(--color-primary);
        `}

      &::after {
        display: none;
      }
    `}

  ${props =>
    props.brand &&
    props.large &&
    css`
      width: 9.1875rem;
    `}

  ${props =>
    props.avatar &&
    css`
      margin: 0 5px !important;
    `}

  ${props =>
    props.burger &&
    css`
      width: 3.75rem;
    `}

  ${props =>
    props.svg &&
    css`
      > img,
      * > img {
        max-height: 24px;
      }
    `}

  ${props =>
    props.disabled &&
    css`
      cursor: default;
      * {
        cursor: default;
      }
    `}

  ${media.lessThan('large')`
    margin: 0 0.5vw;
  `}

  ${media.lessThan('medium')`
    line-height: 3.75rem;
    min-height: 3.75rem;
  `}

  ${media.lessThan('small')`
    margin: 0 4vw;
  `}

  ${media.lessThan('xlarge')`
    margin: 0 1rem;
  `}

  & > a {
    color: inherit;
    text-decoration: inherit;
  }

  ${props =>
    props.active &&
    css`
      color: #f5be2b;
    `}

  &:hover {
    color: #f5be2b;
    transition: all var(--animation-duration) var(--animation-easing);
    ${props =>
      props.disabled &&
      css`
        color: #fff;
      `}

    &:after {
      height: 0.20rem;
      transition: all var(--animation-duration) var(--animation-easing);
    }
  }
`

const NavDownload = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  line-height: 5rem;
  min-height: 5rem;
  color: #ffffff;
  font-size: 1rem;
  text-transform: uppercase;
  white-space: pre;
  transition: all var(--animation-duration) var(--animation-easing);

  ${media.lessThan('medium')`
    display: none;
  `}
`

const Logo = styled.img`
  display: block;
  height: 3.5rem;

  ${media.lessThan('1300px')`
    height: 1.5rem;
  `}
`
const StyledBrandLogo = styled.img.attrs({ src: BrandLogo })`
  height: 60px;
  filter: brightness(0) invert(1);
  transition: filter 0.3s ease;

  &:hover {
    filter: none;
  }

  ${media.lessThan('1300px')`
    height: 70px;
  `}
`

const StyledLink = styled(Link)`
  display: flex;
  font-size: 0.875rem;
  font-family: var(--font-family-ayala-display-sans);
  font-weight: var(--font-weight-boldest);
  letter-spacing: 1px;

  ${props =>
    props.brand &&
    css`
      margin-left: 66px;
    `}
`

const StyledActionButton = styled(ActionButton)`
  display: flex;
  height: 2.25rem !important;
  padding: 0 1rem !important;
  margin-left: 2.5rem;
  margin-right: 1.5rem;
  border: none;
  background: #db6b30;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
    border: none;
  }

  span {
    font-size: 0.75rem;
    color: white;
    opacity: 1 !important;
  }
`

// ST-7330 - [WEB] - Zing Points Download Description
const DownloadAppContainer = styled.div`
  padding: 0.875rem;
  display: none;
  flex-direction: row;
  align-items: center;
  background: #ffffff;

  ${'' /*
  ST-7330 - [WEB] - Zing Points Download Description
  ${props =>
    props.display &&
    css`
      ${media.lessThan('small')`
      display: flex;
    `}
    `} */}
`

// ST-7330 - [WEB] - Zing Points Download Description
const DefaultCloseButton = styled.button`
  flex: 0 0 auto;
  color: #9b9b9b;
  border: 0;
  background: none;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 5px;
  border-radius: 100%;
  outline: none;
  margin-right: 5px;

  > svg {
    vertical-align: baseline;
  }
`

// ST-7330 - [WEB] - Zing Points Download Description
const AppIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  background-image: linear-gradient(135deg, #f39230 0%, #ee485c 100%);
  border-radius: 4px;
  height: 2.25rem;
  width: 2.25rem;
  margin-right: 0.625rem;
`

// ST-7330 - [WEB] - Zing Points Download Description
const AppIcon = styled.img.attrs({ src: Brand })`
  height: 0.875rem;
`

// ST-7330 - [WEB] - Zing Points Download Description
const DownloadDescription = styled.div`
  flex: 1 1 auto;
  font-size: 0.625rem;
  line-height: 0.625rem;
  margin-right: 1rem;
`

// ST-7330 - [WEB] - Zing Points Download Description
const DownloadTitle = styled.h1`
  color: var(--color-primary);
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: var(--letter-spacing);
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 5px;

  ${media.lessThan('small')`
    font-size: 3.2vw;
    line-height: 3.2vw;
  `}
`
// ST-7330 - [WEB] - Zing Points Download Description
const DownloadSubTitle = styled.p`
  font-size: 14px;
  color: #4a4a4a;
  letter-spacing: 0.29px;
  margin: 0;

  ${media.lessThan('small')`
    font-size: 2.7vw;
    line-height: 2.7vw;
  `}
`

// ST-7330 - [WEB] - Zing Points Download Description
const DownloadButton = styled(ActionButton)`
  flex: 0 0 auto;

  ${media.lessThan('small')`
    padding: 0 2vw

    & span {
      font-size: 3vw;
      line-height: 3.5vw;
    }
  `}
`

const ControlledNav = props => {
  const { children, selected } = props
  let modifiedChildren = []

  if (children.length) {
    modifiedChildren = props.children.map(child => {
      const isActive = child.key === selected

      return {
        ...child,
        props: {
          ...child.props,
          active: isActive,
        },
      }
    })
  }
  return <Nav {...props}>{modifiedChildren}</Nav>
}

class Header extends React.Component {
  constructor(props) {
    super(props)
    const { dynamic = true } = props

    this.state = {
      hasBackground: false,
      sideBarState: false,
      searchModalState: false,
      malls: [],
      selectedMallPrompt: false,
      openSelectMall: false,
      displayWelcomeModal: false,
      headerOpacity: dynamic ? 0 : 1,
      errors: {},
    }

    MallApiService.getAllMalls()
      .then(response => {
        this.setState({
          malls: response.data,
        })
      })
      .catch(error => {
        const { errors: errorsObj } = this.state

        errorsObj.allMallsError = error.message
        this.setState({ errors: errorsObj })
      })
  }

  componentDidMount() {
    const {
      accessToken,
      setPrimaryInfo,
      setAccessToken,
      setDeviceLocation,
    } = this.props

    if (accessToken) {
      ProfileApiServices.getProfile(accessToken)
        .then(response => {
          ProfileApiServices.getUserAvatar(accessToken).then(response => {
            const { data } = response
            const urlCreator = window.URL || window.webkitURL
            const avatarUrl = urlCreator.createObjectURL(data)
            if (setPrimaryInfo) {
              setPrimaryInfo({ avatarUrl })
            }
          })

          if (setPrimaryInfo) {
            setPrimaryInfo({
              ...response.data,
            })
          }
        })
        .catch(() => {
          deleteAccessToken()
          deleteUuid()
          if (setPrimaryInfo) {
            setAccessToken(null)
          }
        })
    }

    getDeviceLocation()
      .then(response => {
        setDeviceLocation(response)
      })
      .catch(error => {})

    this.scrollTop()
    this.getNotificationCount()
    window.addEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate(prevProps) {
    const { accessToken, setNotificationCount } = this.props

    if (!accessToken && prevProps !== accessToken) {
      if (setNotificationCount) {
        setNotificationCount(0)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)

    document.querySelector('html').setAttribute('class', '')
    document.querySelector('body').setAttribute('class', '')
  }

  getNotificationCount = async () => {
    const { setNotificationCount, setTicketCount, accessToken } = this.props

    if (accessToken) {
      try {
        const notificationResponse = await NotificationsApiServices.getUnreadNotificationCount(
          accessToken,
        )

        setNotificationCount(notificationResponse.data.value)
      } catch (err) {}

      // REMOVED - getTicketsCount function no longer exists
      // try {
      //   const ticketResponse = await WatchApiServices.getTicketsCount(
      //     accessToken,
      //   )

      //   setTicketCount(ticketResponse.data.value)
      // } catch (err) {}
      setTicketCount(0)
    }
  }

  handleScroll = () => {
    const { dynamic = true } = this.props

    requestAnimationFrame(() => {
      this.setState({
        hasBackground: window.scrollY !== 0,
        headerOpacity: dynamic
          ? areAdsAllowed()
            ? (window.scrollY - 90) / 160
            : window.scrollY / 160
          : 1,
      })
    })
  }

  sideBarToggle = state => {
    document
      .querySelector('html')
      .setAttribute('class', state ? 'sticky-modal-open' : '')
    document
      .querySelector('body')
      .setAttribute('class', state ? 'sticky-modal-open' : '')

    this.setState({
      sideBarState: state,
    })
  }

  searchModalToggle = state => {
    this.setState({
      searchModalState: state,
    })
  }

  profileModalToggle = show => {
    const { displayProfileModal } = this.props

    displayProfileModal(show)
  }

  downloadAppToggle = state => {
    const { setDisplayAppModal } = this.props

    if (!state) {
      const { push, match } = this.props
      setDisplayAppModal(state)

      if (match.url.indexOf('/main/download-app') >= 0) {
        push('')
      }
    }

    setDisplayAppModal(state)
  }

  // ST-7330 - [WEB] - Zing Points Download Description
  downloadAppLink = () => {
    const os = getMobileOS()

    if (os === 'Android') {
      window.location.href = process.env.REACT_APP_PLAY_STORE_URL
    } else if (os === 'iOS') {
      window.location.href = process.env.REACT_APP_APP_STORE_URL
    } else {
      this.downloadAppToggle(true)
    }
  }

  onSearchClick = () => {
    const { selectedMallSlug, initialMall } = this.props

    if (!initialMall && !selectedMallSlug) {
      this.setState({ displayWelcomeModal: true })

      return
    }

    this.searchModalToggle(true)
  }

  handleCloseSelectMall = () => {
    this.setState({ openSelectMall: false })
  }

  displaySelectMalls = () => {
    this.setState({
      openSelectMall: true,
      searchModalState: true,
      selectedMallPrompt: false,
    })
  }

  closeWelcomeModal = () => {
    this.setState({ displayWelcomeModal: false, selectedMallPrompt: true })
  }
  // ST-7330 - [WEB] - Zing Points Download Description
  closeAppBanner = () => {
    const { setDisplayAppBanner } = this.props

    setDisplayAppBanner(false)
  }

  scrollTop() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  }

  handleClickCinema = async e => {
    e.preventDefault()
    !this.props.previewMode && (await doOpenSureSeats())
  }

  render() {
    const {
      sideBarState,
      searchModalState,
      malls,
      selectedMallPrompt,
      openSelectMall,
      displayWelcomeModal,
      headerOpacity,
    } = this.state
    const {
      primaryInfo,
      accessToken,
      match,
      push,
      initialMall,
      displayProfileModal,
      notificationCount,
      ticketCount,
      setFavoriteMalls,
      displayAppBanner,
      selectedMallSlug,
      setSelectedMallSlug,
      displayAppModal,
      favoriteMalls,
      deviceLocation,
      previewMode,
      variant,
      ...restProps
    } = this.props

    const mallList = malls.map(mall => ({
      name: mall.name,
      value: mall.slugName,
    }))

    const { url = '' } = match || {}
    const matchUrl = encodeURI(url)

    const selectedRoute = matchUrl.split('/')[1]

    return (
      <>
        <HeaderContainer {...restProps}>
          {/* ST-7330 - [WEB] - Zing Points Download Description */}

          <DownloadAppContainer display={displayAppBanner}>
            <DefaultCloseButton onClick={this.closeAppBanner}>
              <Icon name="x" />
            </DefaultCloseButton>
            <AppIconContainer>
              <AppIcon />
            </AppIconContainer>

            <DownloadDescription>
              <DownloadTitle>Enjoy 50 Zing Points with the app</DownloadTitle>
              <DownloadSubTitle>Download and register now</DownloadSubTitle>
            </DownloadDescription>

            <DownloadButton
              variant="primary"
              small
              onClick={!previewMode && this.downloadAppLink}
            >
              Get App
            </DownloadButton>
          </DownloadAppContainer>

          <StyledHeader id="header">
            <HeaderBackground
              style={{
                opacity: variant === 'leasing' ? 1 : headerOpacity,
              }}
            />
            <Nav collapse="1300px">
              <NavItem brand large>
                <StyledLink
                  brand
                  to={!previewMode && '/'}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  <StyledBrandLogo src={BrandLogo} />
                </StyledLink>
              </NavItem>
            </Nav>
            <ControlledNav
              align="left"
              collapse="1300px"
              selected={selectedRoute}
            >
              <NavItem key="explore">
                <StyledLink
                  to={!previewMode && `/explore/${selectedMallSlug}`}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  Explore
                </StyledLink>
              </NavItem>
              <NavItem key="promos-and-events">
                <StyledLink
                  to={!previewMode && '/promos-and-events'}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  Promos &amp; Events
                </StyledLink>
              </NavItem>
              <NavItem key="cinema">
                <StyledLink to="" onClick={this.handleClickCinema}>
                  Cinemas
                </StyledLink>
              </NavItem>
              {/*
              ST-7046 - Rewards :: Advanced : Remove Rewards Page
              <NavItem key="rewards">
                <StyledLink
                  to={!previewMode && '/rewards'}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  Rewards
                </StyledLink>
              </NavItem>
              */}
              <NavItem
                key="trade-hall"
                onClick={() => {
                  console.log('Trade Hall button clicked')

                  setGACustomEvent('button_cta', {
                    button_name: 'Trade_hall_button_home',
                  })
                }}
              >
                <StyledLink
                  to={!previewMode && `/trade-hall`}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                  target="_blank"
                >
                  Trade Hall
                </StyledLink>
              </NavItem>
              <NavItem
                key="leasing-inquiry"
                onClick={() => {
                  console.log('Leasing Inquiry button clicked')

                  setGACustomEvent('button_cta', {
                    button_name: 'Leasing_inquiry_button_home',
                  })
                }}
              >
                <StyledLink
                  to={!previewMode && `/leasing-inquiry`}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  Leasing Inquiry
                </StyledLink>
              </NavItem>
              <NavItem key="more">
                <StyledLink
                  to="#"
                  onClick={e => {
                    e.preventDefault()
                    displayProfileModal(true)
                  }}
                >
                  More
                </StyledLink>
              </NavItem>
            </ControlledNav>
            <Nav showOn="1300px">
              <NavItem
                brand
                burger
                onClick={() => !previewMode && this.sideBarToggle(true)}
              >
                <Logo src={Burger} />
              </NavItem>
            </Nav>
            <Nav showOn="1300px">
              <NavItem brand>
                <StyledLink
                  to={!previewMode && '/'}
                  link={previewMode ? 'javascript:void(0)' : undefined}
                >
                  <StyledBrandLogo src={BrandLogo} />
                </StyledLink>
              </NavItem>
            </Nav>
            <Nav>
              <NavDownload key="download">
                <StyledActionButton
                  // onClick={() => !previewMode && this.downloadAppToggle(true)}
                  onClick={() =>
                    accessToken
                      ? this.downloadAppLink()
                      : !previewMode && push('/register')
                  }
                >
                  {accessToken ? 'Download the app' : 'Sign-up now'}
                </StyledActionButton>
              </NavDownload>

              {/* <NavItem avatar>
              </NavItem> */}

              <NavItem svg>
                <Link
                  to={!previewMode && matchUrl}
                  onClick={!previewMode && this.onSearchClick}
                >
                  <Logo src={SearchIcon} />
                </Link>
              </NavItem>
            </Nav>
          </StyledHeader>
        </HeaderContainer>

        <SideNavBar
          selectedMallSlug={selectedMallSlug}
          sideBarState={sideBarState}
          sideBarToggle={this.sideBarToggle}
          navItem={NavItem}
          profileModalToggle={this.profileModalToggle}
          {...this.props}
        />
        {!!searchModalState && (
          <SearchModal
            isOpenSelectMall={openSelectMall}
            onCloseSelectMall={this.handleCloseSelectMall}
            onClose={this.searchModalToggle}
            initialMall={initialMall}
            malls={malls}
            mallList={mallList}
            push={push}
            match={match}
            accessToken={accessToken}
            favoriteMalls={favoriteMalls}
            deviceLocation={deviceLocation}
            setFavoriteMalls={setFavoriteMalls}
            // selectedMallSlug={selectedMallSlug}
            // setSelectedMallSlug={setSelectedMallSlug}
          />
        )}
        <DownloadAppModal
          accessToken={accessToken}
          modalState={displayAppModal}
          onClose={this.downloadAppToggle}
          shouldCloseOnOverlayClick={false}
        />
        <MallWelcomeModal
          show={displayWelcomeModal}
          malls={malls}
          onConfirmClick={this.closeWelcomeModal}
        />

        <SelectMallPromptModal
          show={selectedMallPrompt}
          onConfirmClick={this.displaySelectMalls}
        />
      </>
    )
  }
}

Header.defaultProps = {
  // TODO: specify default props
}

Header.propTypes = {
  // TODO: specify prop types
}

export default Header
